export class UserRoleMappingRequest {
    roleId: number;
    workerId: number;
    active: boolean;
}